import moment from 'moment'
import { applyMask, getCurrentUi } from '../action/Data'
import { isEmpty } from '../action/condition/State'
import objectPath from 'object-path'
import {
  getRequireFieldConfig,
  getRequireFieldKeys,
} from 'designer/component/action/Config'
import {
  INVALID_DATE_MESSAGE,
  INVALID_DATE_TIME_MESSAGE,
  INVALID_DATE_TIME_VALUE,
  INVALID_TIME_MESSAGE,
} from './dateTime'

const REQUIRED_VALIDATION_TITLE = 'กรุณากรอกข้อมูลให้ครบถ้วน'

export const getValidationAlertTitle = (errors = {}) => {
  let messages = Object.values(errors).reduce(
    (result, item) => [...result, ...item],
    [],
  )
  let hasInvalidDate = messages.includes(INVALID_DATE_MESSAGE)
  let hasInvalidTime = messages.includes(INVALID_TIME_MESSAGE)
  let hasInvalidDateTime = messages.includes(INVALID_DATE_TIME_MESSAGE)

  if (hasInvalidDateTime || (hasInvalidDate && hasInvalidTime)) {
    return INVALID_DATE_TIME_MESSAGE
  }
  if (hasInvalidDate) return INVALID_DATE_MESSAGE
  if (hasInvalidTime) return INVALID_TIME_MESSAGE
  return REQUIRED_VALIDATION_TITLE
}

const checkInput = (errors, value, input, key) => {
  let { format, minLength } = input[key]

  if (minLength > 0 && value.length < minLength) {
    errors[key].push('require value at least ' + minLength)
  }

  if (format === 'email') {
    let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (!emailFormat.test(value)) {
      errors[key].push('email wrong format')
    }
  }
  if (format === 'url') {
    let urlFormat =
      /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/i
    if (!urlFormat.test(value)) {
      errors[key].push('url wrong format')
    }
  }
  if (format === 'password') {
    let { requireCase, requireNumber, requireSpecial } = input[key]
    if (requireCase) {
      let lowercase = /[a-z]/g
      let uppercase = /[A-Z]/g
      if (!lowercase.test(value)) {
        errors[key].push('require lowercase at least 1')
      }
      if (!uppercase.test(value)) {
        errors[key].push('require uppercase at least 1')
      }
    }
    if (requireNumber) {
      let numberCase = /[0-9]/g
      if (!numberCase.test(value)) {
        errors[key].push('require number at least 1')
      }
    }
    if (requireSpecial) {
      let specialCase = /[^a-zA-Z0-9\s\*]/g
      if (!specialCase.test(value)) {
        errors[key].push('require special at least 1')
      }
    }
  }
  return errors
}

export const checkError = (jsonForm, values) => {
  let errors = {}
  let validation = jsonForm.validation || {}
  values = {
    ...(jsonForm.formData || {}),
    ...(values || {}),
  }
  let requireKeys = getRequireFieldKeys({
    config: jsonForm.accountConfig,
    jsonForm,
  })
  let validateKeys = [...new Set([...Object.keys(values), ...requireKeys])]

  validateKeys.forEach((key) => {
    errors[key] = errors[key] ? errors[key] : []
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    if (ui?.key !== key) return errors
    let isRequireField = getRequireFieldConfig({
      key,
      config: jsonForm.accountConfig,
      jsonForm,
    })
    let value = objectPath.has(values, key)
      ? objectPath.get(values, key)
      : objectPath.get(values, ui.name)

    let isDateTimeField = ['date', 'time', 'dateTime', 'datetime'].includes(
      ui?.tagname,
    )
    if (isDateTimeField && value === INVALID_DATE_TIME_VALUE) {
      let invalidMessage =
        ui.tagname === 'date'
          ? INVALID_DATE_MESSAGE
          : ui.tagname === 'time'
          ? INVALID_TIME_MESSAGE
          : INVALID_DATE_TIME_MESSAGE
      errors[key].push(invalidMessage)
      return errors
    }
    if (ui?.isShowUi === false || ui?.readonly === true) return errors
    if (!ui?.require && !isRequireField) return errors

    if (isRequireField) {
      let { checked } = jsonForm.require || {}
      if (checked && checked[key]) {
        let checkbox = checked[key].checkbox
        if (values[checkbox] && !value) {
          errors[key].push(`required value`)
        }
      } else {
        if (isEmpty(value) || value === 'Invalid date') {
          errors[key].push(`required value`)
        }
      }
    }
    let { input, inputMask, date, time, checkboxInput, checkboxGroup } =
      validation
    if (input && input[key]) {
      errors = checkInput(errors, value, input, key)
    }
    if (checkboxInput && checkboxInput[key]) {
      let inputKey = checkboxInput[key] ? checkboxInput[key].key : ''
      if (inputKey && values[inputKey]) {
        errors = checkInput(errors, values[inputKey], checkboxInput, key)
      }
    }
    if (checkboxGroup && checkboxGroup[key]) {
      if (key && values[key]) {
        errors = checkInput(errors, values[key], checkboxGroup, key)
      }
    }
    if (inputMask && inputMask[key]) {
      let { mask, maskChar } = inputMask[key]
      if (mask && value) {
        let valueMask = applyMask(value, mask)
        let valueLength = valueMask.replace(maskChar, '').length
        if (valueLength !== mask.length) {
          errors[key].push('value wrong format')
        }
      }
    }
    if (date && date[key]) {
      let { minDate, maxDate } = date[key]
      let start = moment(minDate, 'YYYY-MM-DD')
      let end = moment(maxDate, 'YYYY-MM-DD')
      let current = moment(value, 'YYYY-MM-DD')
      let diffStart = moment.duration(start.diff(current)).asDays()
      let diffEnd = moment.duration(current.diff(end)).asDays()
      if (diffStart > 0 || diffEnd > 0) {
        errors[key].push('วันที่เลือกไม่ได้อยู๋ในช่วงที่กำหนด')
      }
    }
    if (time && time[key]) {
      let { minTime, maxTime } = time[key]
      let now = moment().format('YYYY-MM-DD')
      if (!minTime || !maxTime) return
      let format = minTime.format.replace('hh', 'HH')
      let minTimeValue = moment(minTime.value).format(format)
      let maxTimeValue = moment(maxTime.value).format(format)
      let currentTimeValue = moment(value).format(format)
      let start = moment(`${now} ${minTimeValue}`, 'YYYY-MM-DD HH:mm:ss')
      let end = moment(`${now} ${maxTimeValue}`, 'YYYY-MM-DD HH:mm:ss')
      let current = moment(`${now} ${currentTimeValue}`, 'YYYY-MM-DD HH:mm:ss')
      let diffStart = moment.duration(current.diff(start)).asSeconds()
      let diffEnd = moment.duration(end.diff(current)).asSeconds()
      if (diffStart < 0 || diffEnd < 0) {
        errors[key].push('เวลาที่เลือกไม่ได้อยู๋ในช่วงที่กำหนด')
      }
    }
  })
  return errors
}

export default checkError
